import React from 'react';
import ReactDOM from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';
import { createI18n } from '@pta/i18n';
import App from './App';

const apiBase = (import.meta.env.VITE_API_BASE as string | undefined) ?? 'https://api.szmk-net.hu';
const { i18n } = createI18n({ app: 'feb', apiBase });

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root element not found');

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <I18nextProvider i18n={i18n}>
      <App />
    </I18nextProvider>
  </React.StrictMode>,
);
